import { useEffect, useState } from "react";
import CreateInvoiceWrapper from "./createInvoiceWrapper";

export default function View() {
    return (
        <CreateInvoiceWrapper />
    )
}